import {MessageBox} from '@components/message-box'

export const processRejectReasons = (rejectReasons?: string[]): void => {
  if (!rejectReasons?.length) {
    return
  }

  rejectReasons.forEach(reason => {
    MessageBox.show(reason, 'warning')
  })
}
